/**
 * inno-wizard.js
 *
 * Brand → Dimension → Roof Model wizard for the INNOPRO product page
 * (templates/product.inno.liquid).
 *
 * Flow:
 *   1. User picks a brand   → dimension <select> is populated
 *   2. User picks dimension → roof model variant is selected automatically
 *      by setting #option-1's value and dispatching a native 'change' event
 *      so product-page.js can sync the variant ID and price display.
 *      Compatible model numbers are listed below the roof model select.
 *
 * To add or update brands/dimensions, edit the BRAND_DATA object below.
 * Format: { "Brand": { "Dimension": { roof: "VariantValue", models: ["MODEL1", ...] } } }
 *
 * Excluded (no compatible roof models in the data):
 *   - Lennox
 *
 */

(function () {
  'use strict';

  // ─── Data ──────────────────────────────────────────────────────────────────
  // Key:   brand name (shown in the brand <select>)
  // Value: object whose keys are dimension labels and values are:
  //          roof   – exact <option value=""> in the Shopify roof-model select
  //          models – compatible model numbers to display

  const BRAND_DATA = {
    'Amana': {
      '29"': { roof: '29G', models: ['ALZS4BA1810AA', 'ALZS4BA2410AA', 'ALZS4BA3010AA', 'ALZS4NA1810AA', 'ALZS4NA2410AA', 'ALZS4NA3010AA', 'ALZS5B1810AA', 'ALZS5B2410AA', 'ASZH401810AA', 'ASZH402410AA', 'ASZH403010AA', 'ASZH501810AA', 'ASZN401810AA', 'ASZN402410AA', 'ASZN403010AA'] },
      '35 1/2"': { roof: '36G', models: ['ALZS4BA3610AA', 'ALZS4BA4210AA', 'ALZS4BA4810AA', 'ALZS4BA6010AA', 'ALZS4NA3610AA', 'ALZS4NA4210AA', 'ALZS4NA4810AA', 'ALZS4NA6010AA', 'ALZS5B3010AA', 'ALZS5B3610AA', 'ALZS5B4210AA', 'ALZS5B4810AA', 'ALZS5B6010AA', 'ALZT7CA2410AA', 'ALZT7CA3610AA', 'ALZT7CA4810AA', 'ALZT7CA6010AA', 'ASZC7A2410AA', 'ASZC7A3610AA', 'ASZC7A4810AA', 'ASZC7A6010AA', 'ASZH403610AA', 'ASZH404210AA', 'ASZH404810AA', 'ASZH406010AA', 'ASZH502410AA', 'ASZH503010AA', 'ASZH503610AA', 'ASZH504210AA', 'ASZH504810AA', 'ASZH506010AA', 'ASZN403610AA', 'ASZN404210AA', 'ASZN404810AA', 'ASZN406010AA', 'ASZV902410AA', 'ASZV903610AA', 'ASZV904810AA', 'ASZV906010AA'] },
    },
    'Arcoaire': {
      '31 3/16"': { roof: 'M31G', models: ['H4H5S18AKAAA', 'H4H5S24AKAAA', 'H4H5S30AKAAA', 'H4H5S36AKAAA', 'H4H5S42AKAAA', 'H4H5S48AKAAA', 'HVH837GKA', 'HVH848GKA', 'HVH860GKA'] },
      '35"': { roof: 'L35G', models: ['H4H5S60AKAAA', 'H4H7T24AKAAA', 'H4H7T36AKAAA', 'H4H7T48AKAAA', 'H4H7T60AKAAA'] },
    },
    'Bosch': {
      '29 1/8" x 29 1/8"': {
        roofOptions: [
          { value: '29G',  labelFr: '29G (Gris)',   labelEn: '29G (Grey)' },
          { value: 'B29C', labelFr: 'B29C (Beige)', labelEn: 'B29C (Beige)' },
        ],
        models: ['BOVA-60HDN1-M15G', 'BOVB-36HDN1-M18M', 'BOVB-60HDN1-M18M', 'BOVA-36HDN1-M20G', 'BOVA-60HDN1-M20G', 'BOVB-36HDN1-M20G', 'BOVB-60HDN1-M20G'],
      },
    },
    'Bryant': {
      '31 3/16"': { roof: 'M31C', models: ['215SAN01800A', '215SAN02400A', '215SAN03000A', '215SAN03600A', '215SAN04200A', '215SAN04800A', '225SAN01800A', '225SAN02400A', '225SAN03000A', '225SAN03600A', '225SAN04200A', '225SAN04800A', '235SAN01800A', '235SAN02400A', '235SAN03000A', '235SAN03600A', '235SAN04200A', '235SAN04800A', '288BNV0480004'] },
      '35"': { roof: 'L35C', models: ['215SAN06000A', '225SAN06000A', '227TBN02400A', '227TBN03600A', '227TBN04800A', '227TBN06000A', '235SAN06000A', '284ANV02400A', '284ANV03600A', '284ANV04800A', '284ANV06000A'] },
    },
    'Carrier': {
      '31 3/16"': { roof: 'M31G', models: ['25SCA518A003', '25SCA524A003', '25SCA530A003', '25SCA536A003', '25SCA542A003', '25SCA548A003', '25SPA518A003', '25SPA524A003', '25SPA530A003', '25SPA536A003', '25SPA542A003', '25SPA548A003', '25VNA837A0030', '25VNA848A0030', '25VNA860  A0030', '27SCA518A003', '27SCA524A003', '27SCA530A003', '27SCA536A003', '27SCA542A003', '27SCA548A003', '27SPA618A003', '27SPA624A003', '27SPA630A003', '27SPA636A003', '27SPA642A003', '27SPA648A003'] },
      '35"': { roof: 'L35G', models: ['25SCA560A003', '25SPA560A003', '25TPB724A003', '25TPB736A003', '25TPB748A003', '25TPB760A003', '27SCA560A003', '27SPA660A003'] },
    },
    'Comfortmaker': {
      '31 3/16"': { roof: 'M31G', models: ['C4H5S18KAAA', 'C4H5S24KAAA', 'C4H5S30KAAA', 'C4H5S36KAAA', 'C4H5S42KAAA', 'C4H5S48KAAA', 'CVH837GKA103', 'CVH848GKA104', 'CVH860GKA105'] },
      '35"': { roof: 'L35G', models: ['C4H5S60KAAA', 'C4H7T24AKAAA', 'C4H7T36AKAAA', 'C4H7T48AKAAA', 'C4H7T60AKAAA'] },
    },
    'Daikin': {
      '29"': { roof: '29G', models: ['DZ4SEA1810AA', 'DZ4SEA2410AA', 'DZ4SEA3010AA', 'DZ5SEA1810AA'] },
      '35 1/2"': { roof: '36G', models: ['DZ4SEA3610AA', 'DZ4SEA4210AA', 'DZ4SEA4810AA', 'DZ4SEA6010AA', 'DZ5SEA2410AA', 'DZ5SEA3010AA', 'DZ5SEA3610AA', 'DZ5SEA4210AA', 'DZ5SEA4810AA', 'DZ5SEA6010AA'] },
    },
    'Day & Night': {
      '31 3/16"': { roof: 'M31G', models: ['C4H5S18KAAA', 'C4H5S24KAAA', 'C4H5S30KAAA', 'C4H5S36KAAA', 'C4H5S42KAAA', 'C4H5S48KAAA', 'CVH837GKA103', 'CVH848GKA104', 'CVH860GKA105'] },
      '35"': { roof: 'L35G', models: ['C4H5S60KAAA', 'C4H7T24AKAAA', 'C4H7T36AKAAA', 'C4H7T48AKAAA', 'C4H7T60AKAAA'] },
    },
    'Direct air': {
      '29 1/8" x 29 1/8"': { roof: '29G', models: ['MOVA-36HN1-M152L', 'MOVA-42HN1-M152L', 'MOVA-48HN1-M152L', 'MOVA-60HN1-M152L', 'MOVA-61HN1-M152L'] },
    },
    'Goodman': {
      '29"': { roof: '29G', models: ['GLZS4BA1810AA', 'GLZS4BA2410AA', 'GLZS4BA3010AA', 'GLZS4MA1810AA', 'GLZS4MA2410AA', 'GLZS4MA3010AA', 'GLZS5BA1810AA', 'GLZS5BA2410AA', 'GSZH501810AA', 'GSZM401810AA', 'GSZM402410AA', 'GSZM403010AA'] },
      '35 1/2"': { roof: '36G', models: ['GLZS4BA3610AA', 'GLZS4BA4210AA', 'GLZS4BA4810AA', 'GLZS4BA6010AA', 'GLZS4MA3610AA', 'GLZS5BA3010AA', 'GLZS5BA3610AA', 'GLZS5BA4210AA', 'GLZS5BA4810AA', 'GLZS5BA6010AA', 'GLZT7CA2410AA', 'GLZT7CA3610AA', 'GLZT7CA4810AA', 'GLZT7CA6010AA', 'GSZC7A2410AA', 'GSZC7A3610AA', 'GSZC7A4810AA', 'GSZC7A6010AA', 'GSZH502410AA', 'GSZH503010AA', 'GSZH503610AA', 'GSZH504210AA', 'GSZH504810AA', 'GSZH506010AA', 'GSZM403610AA', 'GSZV902410AA', 'GSZV903610AA', 'GSZV904810AA', 'GSZV906010AA'] },
    },
    'Heil': {
      '31 3/16"': { roof: 'M31G', models: ['H4H5S18AKAAA', 'H4H5S24AKAAA', 'H4H5S30AKAAA', 'H4H5S36AKAAA', 'H4H5S42AKAAA', 'H4H5S48AKAAA', 'HVH837GKA', 'HVH848GKA', 'HVH860GKA'] },
      '35"': { roof: 'L35G', models: ['H4H5S60AKAAA', 'H4H7T24AKAAA', 'H4H7T36AKAAA', 'H4H7T48AKAAA', 'H4H7T60AKAAA'] },
    },
    'Keeprite': {
      '31 3/16"': { roof: 'M31G', models: ['C4H5S18KAAA', 'C4H5S24KAAA', 'C4H5S30KAAA', 'C4H5S36KAAA', 'C4H5S42KAAA', 'C4H5S48KAAA', 'CVH837GKA103', 'CVH848GKA104', 'CVH860GKA105'] },
      '35"': { roof: 'L35G', models: ['C4H5S60KAAA', 'C4H7T24AKAAA', 'C4H7T36AKAAA', 'C4H7T48AKAAA', 'C4H7T60AKAAA'] },
    },
    'Maytag': {
      '30 1/2" x 30 1/2"': { roof: 'M31G', models: ['PSH4BF024K'] },
      '30 3/4" x 30 3/4"': { roof: 'M31G', models: ['CSH4BE018K'] },
      '31 1/4" x 31 1/4"': { roof: 'M31G', models: ['PSH4BE018K'] },
    },
    'Payne': {
      '31 3/16"': { roof: 'M31C', models: ['PH5SAN418004', 'PH5SAN424004', 'PH5SAN430004', 'PH5SAN436004', 'PH5SAN442004', 'PH5SAN448004'] },
      '35"': { roof: 'L35C', models: ['PH5SAN460004', 'PH7TAN42400W', 'PH7TAN43600W', 'PH7TAN44800W', 'PH7TAN46000W'] },
    },
    'Rheem': {
      '29 3/4"': { roof: 'RE29G', models: ['RP14AZ18AJ1NA', 'RP14AZ18AJ2NA', 'RP14AZ24AJ2NA', 'RP15AZ18AJ2NA', 'RP15AZ24AJ2NA', 'RP16AZ24AJ3NA'] },
      '33 3/4"': { roof: 'R33G', models: ['RP14AZ30AJ2NA', 'RP14AZ36AJ2NA', 'RP14AZ42AJ2NA', 'RP14AZ48AJ2NA', 'RP14AZ60AJ2NA', 'RP15AZ30AJ2NA', 'RP15AZ36AJ2NA', 'RP15AZ42AJ2NA', 'RP15AZ48AJ2NA', 'RP15AZ60AJ2NA', 'RP16AZ36AJ3NA', 'RP16AZ48AJ3NA', 'RP16AZ60AJ3NA'] },
    },
    'Ruud': {
      '29 3/4"': { roof: 'RE29G', models: ['RP14AZ18AJ1NA', 'RP14AZ18AJ2NA', 'RP14AZ24AJ2NA', 'RP15AZ18AJ2NA', 'RP15AZ24AJ2NA', 'UP16AZ24AJ3CA'] },
      '33 3/4"': { roof: 'R33G', models: ['RP14AZ30AJ2NA', 'RP14AZ36AJ2NA', 'RP14AZ42AJ2NA', 'RP14AZ48AJ2NA', 'RP14AZ60AJ2NA', 'RP15AZ30AJ2NA', 'RP15AZ36AJ2NA', 'RP15AZ42AJ2NA', 'RP15AZ48AJ2NA', 'RP15AZ60AJ2NA', 'UP16AZ36AJ3CA', 'UP16AZ48AJ3CA', 'UP16AZ60AJ3CA'] },
      '36 1/8"': { roof: 'R36G', models: ['UP2024BJVCA'] },
      '37 1/8"': { roof: 'R36G', models: ['UP2036BJVCA'] },
      '38 1/8"': { roof: 'R36G', models: ['UP2048BJVCA'] },
      '39 1/8"': { roof: 'R36G', models: ['UP2060BJVCA'] },
    },
    'Tempstar': {
      '29 3/4"': { roof: 'RE29G', models: ['RP14AZ18AJ1NA', 'RP14AZ18AJ2NA', 'RP14AZ24AJ2NA', 'RP15AZ18AJ2NA', 'RP15AZ24AJ2NA', 'RP16AZ24AJ3NA', 'UP16AZ24AJ3CA'] },
      '31 3/16"': { roof: 'M31G', models: ['T4H5S18AKAAA', 'T4H5S24AKAAA', 'T4H5S30AKAAA', 'T4H5S36AKAAA', 'T4H5S42AKAAA', 'T4H5S48AKAAA', 'TVH837GKA100', 'TVH848GKA100', 'TVH860GKA100', 'C4H5S18KAAA', 'C4H5S24KAAA', 'C4H5S30KAAA', 'C4H5S36KAAA', 'C4H5S42KAAA', 'C4H5S48KAAA', 'CVH837GKA103', 'CVH848GKA104', 'CVH860GKA105', 'H4H5S18AKAAA', 'H4H5S24AKAAA', 'H4H5S30AKAAA', 'H4H5S36AKAAA', 'H4H5S42AKAAA', 'H4H5S48AKAAA', 'HVH837GKA', 'HVH848GKA', 'HVH860GKA'] },
      '33 3/4"': { roof: 'R33G', models: ['RP14AZ30AJ2NA', 'RP14AZ36AJ2NA', 'RP14AZ42AJ2NA', 'RP14AZ48AJ2NA', 'RP14AZ60AJ2NA', 'RP15AZ30AJ2NA', 'RP15AZ36AJ2NA', 'RP15AZ42AJ2NA', 'RP15AZ48AJ2NA', 'RP15AZ60AJ2NA', 'RP16AZ36AJ3NA', 'RP16AZ48AJ3NA', 'RP16AZ60AJ3NA', 'UP16AZ36AJ3CA', 'UP16AZ48AJ3CA', 'UP16AZ60AJ3CA'] },
      '35"': { roof: 'L35G', models: ['T4H5S60AKAAA', 'T4H7T24AKAAA', 'T4H7T36AKAAA', 'T4H7T48AKAAA', 'T4H7T60AKAAA', 'C4H5S60KAAA', 'C4H7T24AKAAA', 'C4H7T36AKAAA', 'C4H7T48AKAAA', 'C4H7T60AKAAA', 'H4H5S60AKAAA', 'H4H7T24AKAAA', 'H4H7T36AKAAA', 'H4H7T48AKAAA', 'H4H7T60AKAAA'] },
      '36 1/8"': { roof: 'R36G', models: ['UP2024BJVCA'] },
      '37 1/8"': { roof: 'R36G', models: ['UP2036BJVCA'] },
      '38 1/8"': { roof: 'R36G', models: ['UP2048BJVCA'] },
      '39 1/8"': { roof: 'R36G', models: ['UP2060BJVCA'] },
    },
  };

  // ─── Horizontal dimension data ────────────────────────────────────────────
  // Simple fixed options for the horizontal heat-pump flow.
  // Keyed by language prefix so we can localise labels from the page lang attr.

  const HORIZONTAL_DIMS = {
    fr: [
      { label: '33" et moins',      roof: 'S3719' },
      { label: 'Entre 33" et 40"',  roof: 'S4422' },
    ],
    en: [
      { label: '33" and less',          roof: 'S3719' },
      { label: 'Between 33" and 40"',   roof: 'S4422' },
    ],
  };

  // ─── DOM references ────────────────────────────────────────────────────────

  function init() {
    const brandSelect     = document.getElementById('inno-brand');
    const dimSelect       = document.getElementById('inno-dimension');
    const roofModelSelect = document.getElementById('option-1');
    const compatList      = document.getElementById('inno-compat-list');
    const compatField     = document.getElementById('inno-compat-field');
    const descField       = document.getElementById('inno-variant-desc');
    const brandField      = document.getElementById('inno-wizard-brand-field');
    const typeField       = document.getElementById('inno-wizard-type-field');

    if (!brandSelect || !dimSelect || !roofModelSelect) return;

    // ── Load variant descriptions keyed by roof option value ────────────────
    const descDataEl   = document.getElementById('inno-variant-descriptions-json');
    const variantDescs = descDataEl ? JSON.parse(descDataEl.textContent) : {};

    // ── Hide the pre-selected roof model on page load ───────────────────────
    // Shopify always marks the first available variant's option as selected.
    // Visually reset to the placeholder without firing a 'change' event so
    // product-page.js keeps the default variant loaded for price/image.
    roofModelSelect.selectedIndex = 0;

    // Restore the product's default image.
    // product-page.js (which runs before this script) swaps the main image to
    // the pre-selected variant's image.  Since no roof model is chosen yet,
    // revert to the server-rendered default stored in data-default-src.
    const mainImg = document.getElementById('product-main-image');
    if (mainImg && mainImg.dataset.defaultSrc) {
      mainImg.src = mainImg.dataset.defaultSrc;
      mainImg.alt = mainImg.dataset.defaultAlt || '';
    }

    // ── Populate brand options ──────────────────────────────────────────────
    Object.keys(BRAND_DATA)
      .sort()
      .forEach((brand) => {
        const opt = document.createElement('option');
        opt.value = brand;
        opt.textContent = brand;
        brandSelect.appendChild(opt);
      });

    // ── Type selection (vertical / horizontal) ──────────────────────────────
    let currentType = 'vertical';
    const isFr = document.documentElement.lang.startsWith('fr');
    const horizontalDims = isFr ? HORIZONTAL_DIMS.fr : HORIZONTAL_DIMS.en;

    // ── Roof colour choice helpers (Bosch and similar multi-colour entries) ──

    function enableRoofChoice(entry) {
      const allowed = new Set(entry.roofOptions.map((o) => o.value));

      // Hide every real option that isn't in the allowed set; show + relabel the rest
      Array.from(roofModelSelect.options).forEach((opt) => {
        if (!opt.value || opt.disabled) return; // leave the placeholder alone
        if (allowed.has(opt.value)) {
          opt.hidden = false;
          const def = entry.roofOptions.find((o) => o.value === opt.value);
          if (def) {
            if (opt.dataset.origLabel === undefined) opt.dataset.origLabel = opt.textContent;
            opt.textContent = isFr ? def.labelFr : def.labelEn;
          }
        } else {
          opt.hidden = true;
        }
      });

      roofModelSelect.classList.add('is-selectable');
      roofModelSelect.value = entry.roofOptions[0].value;
      roofModelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      renderVariantDesc(descField, variantDescs[entry.roofOptions[0].value] || '');
      renderCompatList(compatList, compatField, entry.models);
    }

    function disableRoofChoice() {
      if (!roofModelSelect.classList.contains('is-selectable')) return;
      Array.from(roofModelSelect.options).forEach((opt) => {
        opt.hidden = false;
        if (opt.dataset.origLabel !== undefined) {
          opt.textContent = opt.dataset.origLabel;
          delete opt.dataset.origLabel;
        }
      });
      roofModelSelect.classList.remove('is-selectable');
    }

    // Update description when user manually picks a colour from the roof select
    roofModelSelect.addEventListener('change', function () {
      if (!roofModelSelect.classList.contains('is-selectable')) return;
      renderVariantDesc(descField, variantDescs[this.value] || '');
    });

    if (typeField) {
      typeField.querySelectorAll('figure[data-type]').forEach((fig) => {
        fig.addEventListener('click', () => selectType(fig.dataset.type));
        fig.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectType(fig.dataset.type);
          }
        });
      });
    }

    function selectType(type) {
      if (type === currentType) return;
      currentType = type;

      // Update ARIA + visual state
      typeField.querySelectorAll('figure[data-type]').forEach((fig) => {
        const isSelected = fig.dataset.type === type;
        fig.classList.toggle('--selected', isSelected);
        fig.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      // Reset downstream state
      disableRoofChoice();
      resetRoofSelect(roofModelSelect);
      clearVariantDesc(descField);
      clearCompatList(compatList, compatField);

      if (type === 'horizontal') {
        // Hide brand select, populate dim select with fixed horizontal options
        if (brandField) brandField.hidden = true;
        brandSelect.value = '';

        dimSelect.innerHTML = '';
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = dimSelect.dataset.placeholder || 'Sélectionner dimension';
        dimSelect.appendChild(placeholder);

        horizontalDims.forEach((entry) => {
          const opt = document.createElement('option');
          opt.value = entry.roof;
          opt.textContent = entry.label;
          dimSelect.appendChild(opt);
        });

        dimSelect.disabled = false;
      } else {
        // Restore vertical flow: show brand select, reset dim select
        if (brandField) brandField.hidden = false;
        brandSelect.value = '';

        dimSelect.innerHTML = '';
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = dimSelect.dataset.placeholder || 'Sélectionner dimension';
        dimSelect.appendChild(placeholder);
        dimSelect.disabled = true;
      }
    }

    // ── Brand change → populate dimensions ─────────────────────────────────
    brandSelect.addEventListener('change', function () {
      const dims = BRAND_DATA[this.value] || {};

      // Reset dimension select
      dimSelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.textContent = dimSelect.dataset.placeholder || 'Sélectionner dimension';
      dimSelect.appendChild(placeholder);

      Object.keys(dims).forEach((dim) => {
        const opt = document.createElement('option');
        opt.value = dim;
        opt.textContent = dim;
        dimSelect.appendChild(opt);
      });

      dimSelect.disabled = false;

      // Reset roof model select, description, and compat list
      disableRoofChoice();
      resetRoofSelect(roofModelSelect);
      clearVariantDesc(descField);
      clearCompatList(compatList, compatField);
    });

    // ── Dimension change → resolve roof model + show compat models ──────────
    dimSelect.addEventListener('change', function () {
      if (currentType === 'horizontal') {
        // In horizontal mode, the option value IS the roof model code
        const roofCode = this.value;
        if (!roofCode) return;

        roofModelSelect.value = roofCode;
        roofModelSelect.dispatchEvent(new Event('change', { bubbles: true }));

        renderVariantDesc(descField, variantDescs[roofCode] || '');
        clearCompatList(compatList, compatField);
        return;
      }

      const brand = brandSelect.value;
      const dim   = this.value;
      const entry = BRAND_DATA[brand]?.[dim];

      if (!entry) return;

      if (entry.roofOptions) {
        // Multiple colour options — make the roof select interactive
        enableRoofChoice(entry);
      } else {
        // Standard single-model case — keep roof select read-only
        disableRoofChoice();
        roofModelSelect.value = entry.roof;
        roofModelSelect.dispatchEvent(new Event('change', { bubbles: true }));
        renderVariantDesc(descField, variantDescs[entry.roof] || '');
        renderCompatList(compatList, compatField, entry.models);
      }
    });
  }

  // ─── Variant description helpers ──────────────────────────────────────────

  function renderVariantDesc(container, html) {
    if (!container) return;
    if (html) {
      container.innerHTML = html;
      container.hidden = false;
    } else {
      container.innerHTML = '';
      container.hidden = true;
    }
  }

  function clearVariantDesc(container) {
    if (!container) return;
    container.innerHTML = '';
    container.hidden = true;
  }

  // ─── Compat list helpers ───────────────────────────────────────────────────

  function renderCompatList(container, field, models) {
    if (!container) return;
    container.innerHTML = '';

    if (!models || models.length === 0) {
      if (field) field.hidden = true;
      return;
    }

    models.forEach((model) => {
      const span = document.createElement('span');
      span.className = '_compat-model';
      span.textContent = model;
      container.appendChild(span);
    });

    if (field) field.hidden = false;
  }

  function clearCompatList(container, field) {
    if (!container) return;
    container.innerHTML = '';
    if (field) field.hidden = true;
  }

  // ─── Helpers ───────────────────────────────────────────────────────────────

  function resetRoofSelect(select) {
    for (let i = 0; i < select.options.length; i++) {
      if (select.options[i].disabled || select.options[i].value === '') {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  // ─── Boot ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
